<div class="container" [ngSwitch]="displayMemorial">
  <app-memory-video *ngSwitchCase="MemorialType.Video"></app-memory-video>
  <app-memory-slides *ngSwitchCase="MemorialType.Slides"></app-memory-slides>
  <div class="mt-4 text-center w-100">
    <button id="memorial-return-button" class="btn btn-primary col-6 col-md-3" (click)="goBack()">
      {{ 'return' | i18n }}
    </button>
  </div>
</div>
